<template lang="pug">
  .component-client-list-filter-form.filter-form
    .row(v-bind:class="{'medium-unstack': rowUnstack}")
      .columns
        .input-group
          input(class="input-group-field" type="text", v-on:keyup="enterSubmit", :placeholder="placeholder", v-model="search.query")
          span(class="input-group-label")
            span(class="fa fa-search", v-on:click="filteredSearch")
      .columns(v-if="balance")
        .input-group
          input(class="input-group-field" type="text", v-on:keyup="balanceSubmit", placeholder="Balance filter", v-model="search.balance")
          span(class="input-group-label", v-on:click="balanceSearch")
            span(class="fa fa-search")
      .columns(v-if="actionButton")
        a.fa.fa-angle-double-down.fa-2x
</template>
<script type="text/babel">

  export default {
    name: "ClientListFilterForm",
    components: {},
    created() {

    },
    data() {
      return {
        search: {
          query: null,
          balance: null
        }
      }
    },
    methods: {
      enterSubmit(e) {
        if (e.keyCode === 13) {
          this.filteredSearch()
        }
      },
      balanceSubmit(e) {
        if (e.keyCode === 13) {
          this.balanceSearch()
        }
      },
      filteredSearch() {
        this.$emit('filteredSearch', this.search)
      },
      balanceSearch() {
        this.$emit('balanceSearch', this.search.balance)
      }
    },
    props: ['placeholder', 'actionButton', 'rowUnstack', 'balance']
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .toggle
    display: none
</style>



// WEBPACK FOOTER //
// SearchInputForm.vue?4de64009